import { parse, subHours, format } from 'date-fns'

export const fixDate = (fechaString: string): string => {
    const fecha = parse(fechaString, 'yyyy/MM/dd HH:mm:ss', new Date())
    // Restamos 5 horas
    const fechaCorregida = subHours(fecha, 5)
    return format(fechaCorregida, 'yyyy/MM/dd HH:mm:ss')
}
